<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :parentId="$route.params.id"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/admin";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "管理者資訊",
              fields: [
                "sequence",
                "name",
                "email",
                "password",
                "roles",
                "scopes",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "啟用設定",
              remark: "停用的管理者將無法使用管理後台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>